import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.a12_1 = this;
        this.b12_1 = this;
        this.c12_1 = false;
      }
      d12(node, permissionsBitmask) {
        var prev = this.b12_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.r1l_1 & permissionsBitmask) === 0 && prev.d12(node, permissionsBitmask));
        } else {
          node.a12_1 = this;
          node.b12_1 = prev;
          prev.a12_1 = node;
          this.b12_1 = node;
          tmp = true;
        }
        return tmp;
      }
      s14(forbiddenElementsBit) {
        this.d12(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      e12() {
        if (this.c12_1)
          return false;
        var prev = this.b12_1;
        var next = this.a12_1;
        prev.a12_1 = next;
        next.b12_1 = prev;
        this.c12_1 = true;
        return true;
      }
      f12(node) {
        if (!(this.a12_1 === this))
          return false;
        this.d12(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.r1l_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
